<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                  @submit="onSubmit"
                  @failed="onFailed"
        >
        <van-cell-group>
            <van-field
                    v-model="formData.danwei"
                    :rules="[{ required: true, message: '单位名称不能为空' }]"
                    label="单位名称"
                    input-align="right"
                    error-message-align="right"
                    left-icon="question-o"
                    @click-left-icon="onQuestion('danwei')"
                    clearable
                    placeholder="请输入单位名称"
            />
            <van-field name="radio" label="类型"
                       input-align="right">
                <template #input>
                    <van-radio-group v-model="formData.kaojitype" direction="horizontal">
                        <van-radio checked-color="#ffb01b" name="考级中心">考级中心</van-radio>
                        <van-radio checked-color="#ffb01b" name="考级点">考级点</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field name="radio"  v-if="formData.kaojitype=='考级中心'" label="考级中心类型"
                       input-align="right">
                <template #input>
                    <van-radio-group v-model="formData.kaoji_jiameng_type"  >
                        <van-radio checked-color="#ffb01b" name="4">指定考级中心（投入成本12万元）</van-radio>
                        <van-radio checked-color="#ffb01b" name="5">样板考级中心（投入成本13.5万元）</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field name="radio" v-else label="考级点类型"
                       input-align="right">
                <template #input>
                    <van-radio-group v-model="formData.kaoji_jiameng_type"  >
                        <van-radio checked-color="#ffb01b" name="2">指定考级点（投入成本0元）</van-radio>
                        <van-radio checked-color="#ffb01b" name="3">样板考级点（投入成本9800元）</van-radio>
                        <van-radio checked-color="#ffb01b" name="7">街舞啦啦操考点</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-cell title="单位执照" :value="formData.zhizhaopic.length+'/1'">
                <template slot="icon" >
                    <van-icon class="question-icon" name="question-o" @click="onQuestion('zhizhaopic')"/>
                </template>
            </van-cell>

            <div class="row">
                <PicUploader :fileList="formData.zhizhaopic" :limit="1"
                             :name="'zhizhaopic'"></PicUploader>
            </div>
            <div class="operate-desc-left">上传营业执照 或 法人证书 或 组织结构代码证</div>

            <van-field
                    v-model="formData.chandimianji"
                    label="场地面积"
                    :rules="[{ required: true, message: '场地面积不能为空' }]"
                    error-message-align="right"
                    type="number"
                    input-align="right"
                    clearable
                    placeholder="请输入场地面积（平米）"
            />


            <van-field
                    v-model="formData.yundongyuanrenshu"
                    :rules="[{ required: true, message: '人数不能为空' }]"
                    error-message-align="right"
                    label="人数"
                    type="number"
                    input-align="right"
                    clearable
                    placeholder="请输入人数"
            />

            <van-field
                    readonly
                    clickable
                    name="area"
                    :value="formData.province+'/'+formData.city+'/'+formData.county"
                    input-align="right"
                    label="地区选择"
                    placeholder="点击选择省市区"
                    @click="showArea = true"
            />
            <van-popup v-model="showArea" position="bottom">
                <van-area
                        :area-list="areaList"
                        :value="formData.area"
                        @confirm="onAreaConfirm"
                        @cancel="showArea = false"
                />
            </van-popup>


            <van-field
                    v-model="formData.address"
                    :rules="[{ required: true, message: '请输入详细地址' }]"
                    error-message-align="right"
                    label="详细地址"
                    input-align="right"
                    clearable
                    placeholder="请输入详细地址"
            />


            <van-cell title="场地照片" :value="formData.changdipic.length+'/5'">
            </van-cell>

            <div class="row">
                <PicUploader :fileList="formData.changdipic" :limit="5"
                             :name="'changdipic'"></PicUploader>
            </div>
            <div class="operate-desc-left">上传5张场地照片</div>



            <van-field
                    v-model="formData.user_code"
                    error-message-align="right"
                    label="个人编码"
                    input-align="right"
                    clearable
                    placeholder="请输入个人编码"
            />

        </van-cell-group>


        <van-divider>负责人信息</van-divider>

        <van-cell-group>

            <van-field
                    v-model="formData.nickname"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                    error-message-align="right"
                    label="姓名"
                    input-align="right"
                    clearable
                    placeholder="请输入姓名"
            />


            <van-field
                    v-model="formData.certificatenumber"
                    :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                    error-message-align="right"
                    label="身份证号"
                    input-align="right"
                    clearable
                    placeholder="请输入身份证号"
            />


            <van-field
                    v-model="formData.email"
                    :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
                    error-message-align="right"
                    label="邮箱"
                    input-align="right"
                    clearable
                    placeholder="请输入邮箱"
            />


            <van-field
                    v-model="formData.phone"
                    :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                    error-message-align="right"
                    label="手机"
                    input-align="right"
                    clearable
                    placeholder="请输入手机"
            />
            <van-field
                    v-if="false"
                    v-model="formData.qq"
                    label="QQ"
                    input-align="right"
                    clearable
                    placeholder="请输入QQ"
            />

            <van-field
                    v-model="formData.weixin"
                    label="微信号"
                    input-align="right"
                    clearable
                    placeholder="请输入微信号"
            />

        </van-cell-group>

        <van-divider>日常联系人信息
        </van-divider>

        <van-cell-group>

            <van-field
                    v-model="formData.contactsname"
                    :rules="[{ required: true, message: '请输入姓名' }]"
                    error-message-align="right"
                    label="姓名"
                    input-align="right"
                    clearable
                    placeholder="请输入姓名"
            />


            <van-field
                    v-model="formData.contactscertificatenumber"
                    :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                    error-message-align="right"
                    label="身份证号"
                    input-align="right"
                    clearable
                    placeholder="请输入身份证号"
            />


            <van-field
                    v-model="formData.contactsemail"
                    :rules="[{ validator: validator.email,message:'请输入正确的邮箱'}]"
                    error-message-align="right"
                    label="邮箱"
                    input-align="right"
                    clearable
                    placeholder="请输入邮箱"
            />


            <van-field
                    v-model="formData.contactsphone"
                    :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                    error-message-align="right"
                    label="手机"
                    input-align="right"
                    clearable
                    placeholder="请输入手机"
            />
            <van-field
                    v-model="formData.contactsqq"
                    label="QQ"
                    v-if="false"
                    input-align="right"
                    clearable
                    placeholder="请输入QQ"
            />

            <van-field
                    v-model="formData.contactsweixin"
                    label="微信号"
                    input-align="right"
                    clearable
                    placeholder="请输入微信号"
            />

        </van-cell-group>

        <div class="savebtn">
            <van-button
                    style="width: 3rem"
                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="保存中..." native-type="submit" @click="save">暂存信息</van-button>

            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交申请</van-button>
        </div>
        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'StationApply',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id: 0,
                    areas:'',
                    province:'',
                    contactsqq:'',
                    qq:'',
                    city:'',
                    county:'',
                    kaojitype:'考级中心',
                    kaoji_jiameng_type:'',
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    changdipic: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [],
                },
            }
        },
        filters: {},
        mounted() {
            document.title="创建七彩星级"
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
//            if(that.formData.id){
            this.fetch();
//            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;

                if(that.formData.kaojitype == '考级中心'){
                    if(that.formData.kaoji_jiameng_type != 4 && that.formData.kaoji_jiameng_type != 5 ){
                        Toast('请选择考级中心类型');
                        return ;
                    }
                }else if(that.formData.kaojitype == '考级点'){
                    if(that.formData.kaoji_jiameng_type != 2 && that.formData.kaoji_jiameng_type != 3&& that.formData.kaoji_jiameng_type != 7 ){
                        Toast('请选择考级点类型');
                        return ;
                    }
                }

                for (let field in that.formData) {

                    if (that.formData.changdipic.length != 5) {
                        Toast('请上传5张场地照片');
                        return
                    }
                    if (that.formData.zhizhaopic.length == 0) {
                        Toast('请上传单位执照');
                        return
                    }
                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                }
                that.saveLoading = true;

                if (that.submitType =='save') {
                    that.$api.post('/api/examecenter/save', that.formData, (res) => {
                        that.saveLoading = false;
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                } else {
                    that.$api.post('/api/examecenter/apply', that.formData, (res) => {
                        that.saveLoading = false;
                        rbLink({
                            name:"QcxjStationResult",
                            query:{
                                id:res.data.id
                            }
                        },'replace')
                    }, (res) => {
                        Toast.fail(res.msg);
                        that.saveLoading = false;
                    })
                }
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/examecenter/centerdetail', {
                    id:that.formData.id
                }, (res) => {
                    that.formData = res.data;
                    if(res.data.kaojiregist_status ==1 || res.data.kaojiregist_status == 2){
                        rbLink({
                            name:"QcxjStationResult",
                            query:{
                                id:res.data.id
                            }
                        },'replace')
                    }
                }, (res) => {
//                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// StationApply.vue?570d7e69